import { Button, DropdownItem, HFlow, Tooltip } from 'bold-ui'
import React from 'react'

export interface MenuAcoesAgendamentoButtonProps {
  icon: React.ReactElement
  text: string
  tooltip?: string
  isDropdown?: boolean
  loading?: boolean
  disabled?: boolean
  type?: 'normal' | 'danger'
  buttonRef?: React.Ref<HTMLButtonElement>
  onClick?(): void
}

export default function MenuAcoesAgendamentoButton(props: MenuAcoesAgendamentoButtonProps) {
  const { icon, text, isDropdown, tooltip, loading, buttonRef, onClick, disabled = false, type = 'normal' } = props
  return (
    <Tooltip text={tooltip}>
      {isDropdown ? (
        <DropdownItem type={type} onClick={onClick} disabled={disabled}>
          <HFlow alignItems='center'>
            {icon} {text}
          </HFlow>
        </DropdownItem>
      ) : (
        <Button size='small' skin='ghost' loading={loading} onClick={onClick} disabled={disabled} innerRef={buttonRef}>
          {icon}
        </Button>
      )}
    </Tooltip>
  )
}
